import { useEffect, useRef } from "react";

const useDidUpdateEffect = (fn: () => void, inputs: any[]) => {
  const isMountingRef = useRef(false);

  useEffect(() => {
    isMountingRef.current = true;
  }, []);

  useEffect(() => {
    !isMountingRef.current ? fn() : (isMountingRef.current = false);
  }, inputs);
};

export default useDidUpdateEffect;
